export const FETCH_LOAD_TRASH_ROLES_REQUEST = 'FETCH_LOAD_TRASH_ROLES_REQUEST'
export const FETCH_LOAD_TRASH_ROLES_SUCCESS = 'FETCH_LOAD_TRASH_ROLES_SUCCESS'
export const FETCH_LOAD_TRASH_ROLES_FALUIRE = 'FETCH_LOAD_TRASH_ROLES_FALUIRE'
export const SEARCH_DELETED_ROLES = 'SEARCH_DELETED_ROLES'

